import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import bugsnag from 'bugsnag-js';
import bugsnagReact from 'bugsnag-react';
import { StripeProvider } from 'react-stripe-elements';

import 'core/font-awesome';
import App from './App';
import * as serviceWorker from './serviceWorker';
import configureStore from './core/store/configure';

const store = configureStore();
const client = bugsnag({
  apiKey: 'e5df3ba1237485feef05100333ccf784',
  releaseStage: process.env.REACT_APP_ENV,
});
const ErrorBoundary = client.use(bugsnagReact(React));
const apiKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY

ReactDOM.render((
  <ErrorBoundary>
    <Provider store={store}>
      <Router>
        <StripeProvider apiKey={apiKey}>
          <App />
        </StripeProvider>
      </Router>
    </Provider>
  </ErrorBoundary>
), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();



// WEBPACK FOOTER //
// ./src/index.js